import { Tabs } from "@/components/Elements";
import { usePostViewQuery } from "@/services/modules/post";
import { useMemo } from "react";
import {
  FriendSuggestionList,
  FriendRequestList,
  RecipientList,
} from "./friend";
import { FriendTab } from "../types";
import { useParams } from "react-router-dom";

export const FriendScreen = () => {
  usePostViewQuery();
  const { defaultTab } = useParams<{ defaultTab?: string }>();

  const tabs = useMemo(
    () => [
      {
        id: FriendTab.Suggestions,
        label: FriendTab.Suggestions,
        Content: () => <FriendSuggestionList />,
      },
      {
        id: FriendTab.Requests,
        label: FriendTab.Requests,
        Content: () => <FriendRequestList />,
      },
      {
        id: FriendTab.Friends,
        label: FriendTab.Friends,
        Content: () => <RecipientList />,
      },
    ],
    []
  );

  return (
    <div className="flex-1">
      <Tabs tabs={tabs} defaultTabId={defaultTab} />
    </div>
  );
};
